import { USE_MOCKS, api, mockDelay } from "@/lib/api"

/**
 * Lecturas que alimentan el Dashboard del lado CONTABLE.
 *
 * Los dos endpoints existian y no los consumia ninguna pantalla:
 * `/classify/metrics` es el indicador de si el motor esta mejorando —si la
 * cobertura de regla y memoria sube y la de LLM baja, el sistema se abarata
 * solo— e `/ingest/summary` detecta el problema mas comun de la operacion:
 * comprobantes que entraron y nunca se contabilizaron, que aparecen recien
 * cuando la declaracion no cuadra.
 *
 * El lado financiero lo cubre `@/routes/finance/api`: se reutiliza en vez de
 * duplicarse, para que el Dashboard no pueda decir un numero distinto del que
 * dice la pantalla de Finanzas.
 */

export interface ClassifyMetrics {
  por_capa: Record<string, { documentos: number; confianza_media: number }>
  total: number
  tasa_correccion_humana: number
  nota: string
}

export interface IngestSummary {
  por_canal: Record<string, number>
  por_estado: Record<string, number>
  sin_normalizar: number
  alerta: string | null
}

export async function fetchClassifyMetrics(): Promise<ClassifyMetrics> {
  if (USE_MOCKS) {
    return mockDelay<ClassifyMetrics>({
      por_capa: {}, total: 0, tasa_correccion_humana: 0, nota: "",
    })
  }
  return api.get<ClassifyMetrics>("/classify/metrics")
}

export async function fetchIngestSummary(): Promise<IngestSummary> {
  if (USE_MOCKS) {
    return mockDelay<IngestSummary>({
      por_canal: {}, por_estado: {}, sin_normalizar: 0, alerta: null,
    })
  }
  return api.get<IngestSummary>("/ingest/summary")
}
